export default "__VITE_ASSET__BIOrx6LF__"